class Carousel {
    constructor(parentElementId) {
            ///////////////// JAVASCRIPT VARIABLES ////////////////
    this.parentElement = document.getElementById(`${parentElementId}`)
    this.isMobile = window.innerWidth > 768 ? false : true;
    this.ccCarouselSelectedIndex = 0;
    this.ccCarouselAutoInterval = null;
    this.featuresCarouselScrollTimeout = null;
    this.ccCarouselIntervalTime = 10000;
    this.carouselScrollLeft = 0;
    this.touch = null;
    this.slidesParent = this.isMobile == false ? this.parentElement.querySelector('.cc-carousel-slides-parent-desktop') : this.parentElement.querySelector('.cc-carousel-slides-parent-mobile')
    this.totalSlides = this.isMobile == false ? this.parentElement.dataset.totalSlides : this.parentElement.dataset.totalSlidesMobile
    this.divWidth = this.isMobile == false ? this.parentElement.dataset.divWidth : this.parentElement.dataset.divWidthMobile
    this.slideWidth = this.isMobile == false ? this.parentElement.dataset.slideWidth : this.parentElement.dataset.slideWidthMobile
    this.productsPerRow = this.isMobile == false ? parseInt(this.parentElement.dataset.productsPerRow) : parseInt(this.parentElement.dataset.productsPerRowMobile)

    if(this.isMobile){
      this.parentElement.querySelector('.cc-carousel-slides-parent-desktop').style.display = 'none'
    }
    else{
      this.parentElement.querySelector('.cc-carousel-slides-parent-mobile').style.display = 'none'

    }
    //////////////// GET ELEMENTS ///////////////

    this.carouselScrollDiv = this.parentElement.querySelector('.scrolldiv-carousel');
    this.slidesParent.style.width = this.divWidth
    
    this.slides = this.isMobile == false ? this.parentElement.querySelectorAll('.cc-carousel-item-desktop') : this.parentElement.querySelectorAll('.cc-carousel-item-mobile')
    this.prevButton = this.parentElement.querySelector('.prev-slide');
    this.nextButton = this.parentElement.querySelector('.next-slide');
    //////////////// ADD LISTENERS ///////////////


    this.prevButton.addEventListener('click', (event) => this.prevSlidePress(event));
    this.nextButton.addEventListener('click', (event) => this.nextSlidePress(event));
    this.addFocusListeners()
    
    this.setSlidesWidth()
    this.showHideButtons()
    }


    //////////////// METHODS ///////////////
    setSlidesWidth(){
      if(!this.isMobile){

        for(let i = 0; i < this.slides.length; i++){
          
          this.slides[i].style.width = this.slideWidth;
        }
      }
    }
    showHideButtons(){
      if(this.isMobile){
        this.prevButton.style.display = "none"
        this.nextButton.style.display = "none"

      }
    }
    nextSlidePress() {

      // this.slideSetAuto(); // Reset auto interval
      this.nextSlide();
    }
    prevSlidePress() {

      if (this.ccCarouselSelectedIndex == 0) return;
      // this.slideSetAuto(); // Reset auto interval
      this.prevSlide();
    }
    setCarouselIndex(index) {
      // this.slideSetAuto(); // Reset auto interval
      this.ccCarouselSelectedIndex = index - 1;
      this.setCarouselScroll();
    }
    nextSlide = () => {
      this.ccCarouselSelectedIndex = (this.ccCarouselSelectedIndex + 1) % this.totalSlides;
      this.setCarouselScroll();
    }
    prevSlide() {
      if (this.ccCarouselSelectedIndex === 0) {
        return
        }
        else {
            this.ccCarouselSelectedIndex--;
        this.setCarouselScroll();
        }
    }

    updateFeatureDots() {
      for (let i = 0; i < featureDots.length; i++) {
        if (i === this.ccCarouselSelectedIndex) {
          featureDots[i].classList.add('bg-copper');
          featureDots[i].classList.remove('bg-gray-300');
        } else {
          featureDots[i].classList.remove('bg-copper');
          featureDots[i].classList.add('bg-gray-300');
        }
      }
    }

    setCarouselScroll() {
      if (!this.carouselScrollDiv) return;
      this.carouselScrollDiv.scrollLeft = this.carouselScrollDiv.clientWidth * this.ccCarouselSelectedIndex;
      this.carouselScrollLeft = this.carouselScrollDiv.scrollLeft;
    }

    featureTouchstart(e) {
      touch = new TouchEvent(e);
    }

    featureTouchend(e) {
      if (!touch) return;
      touch.setEndEvent(e);
      if (touch.isSwipeRight()) prevPress();
      else if (touch.isSwipeLeft()) nextPress();
      touch = null;
    }

    slideSetAuto() {
      clearInterval(this.ccCarouselAutoInterval);
      this.ccCarouselAutoInterval = setInterval(this.nextSlide, this.ccCarouselIntervalTime);
    }

    addFocusListeners(){
      for(let i = 0; i < this.slides.length; i++){
        this.slides[i].querySelector('.product-thumb-link').addEventListener('focus', ()=>{this.handleSlideFocus(i)})
      }
    }

    handleSlideFocus(index){
      let correctSlide = Math.floor(index/this.productsPerRow)
      if(this.ccCarouselSelectedIndex != correctSlide){
        setTimeout(()=>{this.ccCarouselSelectedIndex < correctSlide ? this.nextSlidePress() : this.prevSlidePress()}, 100)
      }
    }

}

let carousels = {}
const carouselElements = document.getElementsByClassName('cc-carousel-parent')
for (let i = 0; i < carouselElements.length; i++){
    setTimeout(()=>{
      carousels[`${carouselElements[i].id}`] = new Carousel(carouselElements[i].id)

    }, 10)
}
